import React, { useState } from "react";
import AgencyProfile from "./AgencyProfile";
import UserManagement from "./UserManagement";
import AuditLog from "./AuditLog";
import { Building2, Users, FileText } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const TABS = [
  { key: "profile", label: "Agency Profile", icon: Building2, component: AgencyProfile },
  { key: "users", label: "Users", icon: Users, component: UserManagement, roles: ["platform_owner", "agency_admin"] },
  { key: "audit", label: "Audit Log", icon: FileText, component: AuditLog, roles: ["platform_owner", "agency_admin"] },
];

export default function Settings() {
  const { user } = useAuth();
  const [active, setActive] = useState("profile");
  const allowed = TABS.filter((t) => !t.roles || t.roles.includes(user?.role));
  const Active = (allowed.find((t) => t.key === active) || allowed[0])?.component || AgencyProfile;

  return (
    <div className="px-4 md:px-8 py-6 md:py-8 max-w-6xl mx-auto">
      <header className="mb-6">
        <div className="overline mb-2">Settings</div>
        <h1 className="heading-display">Configure your workspace</h1>
      </header>

      <div className="flex gap-1 mb-6 border-b border-border overflow-x-auto scrollbar-thin" data-testid="settings-tabs">
        {allowed.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors inline-flex items-center gap-1.5 whitespace-nowrap ${
                active === t.key ? "" : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
              style={active === t.key ? { borderColor: "hsl(var(--primary))", color: "hsl(var(--primary))" } : {}}
              data-testid={`settings-tab-${t.key}`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      <Active />
    </div>
  );
}
